import type { Bridge } from '../../contracts/bridge';
import { BotIcon, MoonIcon, SunIcon, SettingsIcon, DownloadIcon } from '../common/Icons';

interface TaskbarProps {
  selectedBridge: Bridge | null;
  onThemeToggle: () => void;
  theme: 'light' | 'dark';
  onSettingsClick: () => void;
  onExportClick: () => void;
  onLLMClick: () => void;
}

export function Taskbar({
  selectedBridge,
  onThemeToggle,
  theme,
  onSettingsClick,
  onExportClick,
  onLLMClick,
}: TaskbarProps) {
  return (
    <header className="taskbar">
      <div className="flex items-center gap-4">
        <h1 className="text-lg font-semibold">Bridge Ice Risk</h1>
        {selectedBridge && (
          <span className="text-sm text-secondary">
            {selectedBridge.name}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2 ml-auto">
        <button
          className="btn btn--ghost btn--icon"
          onClick={onLLMClick}
          data-testid="llm-button"
          title="AI Assistant"
        >
          <BotIcon />
        </button>
        <button
          className="btn btn--ghost btn--icon"
          onClick={onThemeToggle}
          data-testid="theme-toggle"
          title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        >
          {theme === 'light' ? <MoonIcon /> : <SunIcon />}
        </button>
        <button
          className="btn btn--ghost btn--icon"
          onClick={onSettingsClick}
          data-testid="settings-button"
          title="Settings"
        >
          <SettingsIcon />
        </button>
        <button
          className="btn btn--ghost btn--icon"
          onClick={onExportClick}
          data-testid="export-button"
          title="Export"
        >
          <DownloadIcon />
        </button>
      </div>
    </header>
  );
}
